// Swiper initialization with conditional desktop disable when slides <= 3
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-swiper-after-hero]');
  if (!container || typeof Swiper === 'undefined') return;

  const wrapper = container.querySelector('.swiper-wrapper');
  const slides = () => wrapper.querySelectorAll('.swiper-slide');
  const DESKTOP_BREAKPOINT = 1024; // >= 1024 px
  let swiperInstance = null;

  function enableSwiper() {
    if (swiperInstance) return; // already active
    const count = slides().length;
    // eslint-disable-next-line no-undef
    swiperInstance = new Swiper(container, {
      loop: count > 1,
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow: true,
      pagination: {
        el: container.querySelector('[data-after-hero-pagination]'),
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  }

  function disableSwiper() {
    if (!swiperInstance) return;
    swiperInstance.destroy(true, true); // cleanup styles & classes Swiper added
    swiperInstance = null;
  }

  function applyMode() {
    const count = slides().length;
    const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
    const shouldBeStaticDesktop = isDesktop && count <= 3;
    if (shouldBeStaticDesktop) {
      disableSwiper();
      // Optional: ensure wrapper lays out slides nicely when static
      wrapper.style.display = 'flex';
      wrapper.style.gap = '24px';
    } else {
      // Remove static styling if previously applied
      wrapper.style.removeProperty('display');
      wrapper.style.removeProperty('gap');
      enableSwiper();
    }
  }

  applyMode();

  // Debounced resize handler
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyMode, 120);
  });
});
